import { ImageProps as NextImageProps } from 'next/image';

import { twMerge } from 'tailwind-merge';

import { ContentfullAssetFragment } from '@/gql/__generated/graphql.types';

import Image from './Image';

export interface CtfImageProps extends Omit<ContentfullAssetFragment, '__typename'> {
  nextImageProps?: Omit<NextImageProps, 'src' | 'alt' | 'quality' | 'placeholder' | 'blurDataURL'>;
}

export const CtfImage = ({ url, width, height, title, nextImageProps }: CtfImageProps) => {
  if (!url || !width || !height) {
    return null;
  }

  return (
    <Image
      src={url}
      width={width}
      height={height}
      alt={title || ''}
      sizes="(max-width: 1200px) 100vw, 50vw"
      {...nextImageProps}
      className={twMerge(nextImageProps?.className, 'py-4 transition-all')}
    />
  );
};
